import { WorkoutMode } from '@kinomap-dev/ng-ui-lib/core';

/**
 * Unite affichee des valeurs par mode.
 * `incSpd` : le graphe affiche son premier champ (`inc`), d'ou le `%`.
 */
export const WORKOUT_MODE_UNITS: Readonly<Record<WorkoutMode, string>> = {
    ftp: '%',
    watts: 'W',
    res: '%',
    slope: '%',
    inc: '%',
    spd: 'km/h',
    incSpd: '%',
};

/** Unite utilisee quand aucun mode n'est defini (resistance par defaut). */
export const DEFAULT_WORKOUT_MODE_UNIT: string = WORKOUT_MODE_UNITS.res;
